import { ReactComponent as IconTick } from '@/assets/svgs/tick.svg';
import classname from 'classnames';

export const Checkbox = ({ ['data-testid']: dataTestId, addClass, selected, handleUpdateItemSelect = null, disabled, indeterminate }) => {
	const checkBoxClass = classname(
		addClass, {
		"checkbox": true,
		"checkbox--active": selected,
		"checkbox--disabled": disabled,
		"checkbox--indeterminate": indeterminate,
	});

	return (
		<div
			data-testid={dataTestId}
			className={checkBoxClass}
			role="checkbox"
			tabIndex={0}
			onClick={() => !disabled && handleUpdateItemSelect && handleUpdateItemSelect(!selected)}
			onKeyDown={() => !disabled && handleUpdateItemSelect && handleUpdateItemSelect(!selected)}
		>
			{selected ? <IconTick /> : null}
		</div>
	);
};

export default Checkbox;
